exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#v_app[data-v-0deb0842] {\n  height: 100%;\n}\n.wrapper-box[data-v-0deb0842] {\n  height: 100%;\n}", ""]);

// exports
